export enum PaymentStatusEnum {
  PENDING = "Pending",
  PAID = "Paid",
  CANCELED = "Canceled",
}

export enum PaymentStatusCopiedEnum {
  Pending = "Pending",
  Paid = "Paid",
  Canceled = "Canceled",
}
